import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Avatar, Row } from 'antd';
import PageHeader from '../../components/PageHeader/PageHeader';
import { UserOutlined } from '@ant-design/icons';
import MapFrance from './MapFrance';
import zones from './zones';
import Logo from '../../assets/images/logo-assurmax.png';
import useAuthContext from '../../contexts/AuthContext';
import useErrorMessage from '../../utils/ErrorMessage';
import ContentCustom from '../../components/ContentCustom/ContentCustom';
import DescriptionList from '../../components/DescriptionList/DescriptionList';

const Contacts = () => {
  const { t } = useTranslation();
  const { dispatchAPI, user } = useAuthContext();
  const [inspector, setInspector] = useState({});
  const { message } = useErrorMessage();

  const assurmax_fields = [
    {
      name: ['tel'],
      label: t('contacts.menuContact.byPhone'),
      content: (
        <a href={`tel:${t('contacts.menuContact.info.phone')}`}>
          {t('contacts.menuContact.info.phone')}
        </a>
      ),
      span: 3
    },
    {
      name: ['mail'],
      label: t('contacts.menuContact.byMail'),
      content: (
        <a
          target="_blank"
          rel="noopener noreferrer"
          href={`mailto:${t('contacts.menuContact.info.mail')}`}
        >
          {t('contacts.menuContact.info.mail')}
        </a>
      ),
      span: 3
    },
    {
      name: ['address'],
      label: t('contacts.menuContact.byCourrier'),
      content: t('contacts.menuContact.info.address'),
      span: 3
    }
  ];

  const inspector_fields = [
    {
      name: ['name'],
      label: 'Nom',
      content: inspector && `${inspector.first_name} ${inspector.last_name}`,
      span: 3
    },
    {
      name: ['tel'],
      label: t('contacts.menuContact.byPhone'),
      content: inspector && (
        <a href={`tel:${inspector.phone_number}`}>{inspector.phone_number}</a>
      ),
      span: 3
    },
    {
      name: ['mail'],
      label: t('contacts.menuContact.byMail'),
      content: inspector && (
        <a href={`mailto:${inspector.email}`}>{inspector.email}</a>
      ),
      span: 3
    }
    // {
    //   name: ['address'],
    //   label: t('contacts.menuContact.byCourrier'),
    //   content: t('contacts.menuContact.info.address'),
    //   span: 3
    // }
  ];

  const getInspector = async () => {
    try {
      const { data } = await dispatchAPI('GET', {
        url: `/inspectors/zone/${user?.insurer?.zone}`
      });
      setInspector(data[0]);
    } catch (e) {
      if (e.response) message(e.response.status);
    }
  };

  useEffect(() => {
    (async () => {
      await getInspector();
    })();
    // eslint-disable-next-line
  }, []);

  const style = {
    container: {
      width: '100%',
      backgroundColor: 'white',
      borderRadius: '10px',
      display: 'flex',
      flexDirection: 'column',
      padding: '20px'
    },
    head: {
      fontWeight: 'bold',
      color: '#0C5787',
      lineHeight: 2
    },
    subContainer: {
      width: '100%',
      display: 'flex',
      flexWrap: 'wrap'
    },
    descList: {
      margin: '0 0 0 10px',
      width: '400px'
    }
  };

  return (
    <>
      <PageHeader title={t('contacts.title')} />
      <ContentCustom>
        <Row>
          <div style={style.container}>
            <h3 style={style.head}>{t('contacts.menuContact.title1')}</h3>
            <div style={style.subContainer}>
              <div
                style={{
                  width: '200px',
                  margin: '25px 0 10px 10px',
                  justifyContent: 'center',
                  alignItems: 'center',
                  minHeight: 55
                }}
              >
                <img alt="Logo" style={{ width: '200px' }} src={Logo} />
              </div>
              <div style={style.descList}>
                <DescriptionList data={assurmax_fields} />
              </div>
            </div>
          </div>
        </Row>
      </ContentCustom>
      <ContentCustom>
        <Row>
          <div style={style.container}>
            <h3 style={style.head}>{t('contacts.menuContact.title2')}</h3>
            <div style={style.subContainer}>
              <div
                style={{
                  margin: '25px 0 0 10px',
                  justifyContent: 'center',
                  alignItems: 'center'
                }}
              >
                {inspector && inspector.photo ? (
                  <Avatar size={60} src={inspector.photo} />
                ) : (
                  <Avatar
                    size={60}
                    style={{ backgroundColor: '#87d068' }}
                    icon={<UserOutlined />}
                  />
                )}
              </div>
              <div style={style.descList}>
                <DescriptionList data={inspector_fields} />

                <div
                  style={{
                    justifyContent: 'center',
                    alignItems: 'center',
                    fontWeight: 'bold',
                    color: '#0C5787',
                    fontSize: 26,
                    marginBottom: 15
                  }}
                >
                  <span
                    style={{
                      whiteSpace: 'no-wrap',
                      fontSize: 12
                    }}
                    className="ant-descriptions-item-label"
                  >
                    Le mot de l&apos;inspecteur
                  </span>
                  {inspector && inspector.comment ? `${inspector.comment}` : ''}
                </div>
              </div>
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  height: 'auto',
                  minWidth: '250px',
                  flexGrow: 3
                }}
              >
                <div style={{ height: 'auto', marginRight: '0' }}>
                  <MapFrance
                    containerStyle={{ minWidth: '250px', maxWidth: '500px' }}
                    selectedZones={zones[user?.insurer?.zone - 1]}
                  />
                </div>
              </div>
            </div>
          </div>
        </Row>
      </ContentCustom>
    </>
  );
};

export default Contacts;
